export default __webpack_public_path__ + "static/media/OpenSans.165e521e.ttf";